import { enrollmentsActionTypes } from '@constants/actionTypes/ssapActionTypes';

export const INITIAL_STATE = {
    atomized: {},
    bulk: [],
    isDataFetched: false
};

export default (state = INITIAL_STATE, action = {}) => {
    switch (action.type) {
        case enrollmentsActionTypes.SET_BULK_ENROLLMENTS:
            return {
                ...state,
                bulk: action.enrollments
            };
        case enrollmentsActionTypes.SET_ENROLLMENT:
            return {
                ...state,
                atomized: {
                    ...state.atomized,
                    [action.applicantGuid]: action.isEnrolled
                }
            };
        case enrollmentsActionTypes.SET_PROGRESS:
            return {
                ...state,
                isDataFetched: action.isDataFetched
            };
        case enrollmentsActionTypes.CLEAR_SSAP_STATE:
            return INITIAL_STATE;
        default:
            return state;
    }
};

// Selectors

export const getApplicantGuidsFromEnrollments = state => state.bulk.map(enrollment => enrollment.memberGuid);
export const selectAtomizedEnrollments = state => state.atomized;
export const selectBulkEnrollments = state => state.bulk;
export const selectIsDataFetched = state => state.isDataFetched;